import React from 'react'
import { Navigate } from 'react-router-dom'
import { Spinner } from 'flowbite-react'

export default function ProtectedRoute({ user, familyId, loading, children }) {
  if (loading) {
    return (
      <div className="flex justify-center items-center mt-10">
        <Spinner size="xl" />
      </div>
    )
  }

  if (!user) {
    return <Navigate to="/auth" replace />
  }

  // If user has no family selected, JoinOrCreateFamily is shown at App level
  if (!familyId) {
    return (
      <div className="flex justify-center items-center mt-10">
        <Spinner size="xl" />
      </div>
    )
  }

  return children
}
